import React, { useEffect, useState } from 'react';
import { Box, Container, Typography } from '@mui/material';
import SecondaryButton from './Assets/SecondaryButton';
import teamWork from './images/2558.png';
import './Assets/LandingRoute.css';

export default function OurTeamSection() {
  const [scrollPosition, setScrollPosition] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      setScrollPosition(window.scrollY);
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const isMobile = window.innerWidth <= 768;
  const slideRightClass = isMobile ? '' : scrollPosition > 950 ? 'aboutSlide-right show' : 'aboutSlide-right';
  const slideLeftClass = isMobile ? '' : scrollPosition > 950 ? 'aboutSlide-left show' : 'aboutSlide-left';


  return (
    <Box sx={{ py: 6 }}>
      <Container maxWidth="lg" component="section">
        {/* Section Title */}
        <Box textAlign="center" mb={4}>
          <Typography
            variant="h4"
            sx={{ fontFamily: 'Poppins', fontWeight: '600' }}
          >
            OUR TEAM AND COMMITMENT
          </Typography>
        </Box>

        {/* Content */}
        <Box
          sx={{
            display: 'flex',
            flexDirection: {
              xs: 'column',
              md: 'row',
            },
            justifyContent: 'center',
            gap: 4,
            alignItems: 'center',
          }}
        >
          <Box sx={{ flex: 1 }} className={slideLeftClass}>
            <Typography
              variant="body1"
              color="text.secondary"
              paragraph
              fontSize={isMobile ? '1rem' : '1.2rem'}
              mt={3}
            >
              <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.6 }}>
                At <strong>InnoWave API Hub</strong>, we are a team of passionate innovators, developers, and API
                specialists dedicated to building high-performance, scalable, and secure API solutions. With
                expertise in <strong>cloud computing</strong>, <strong>security</strong>, and <strong>enterprise integrations</strong>,
                our team ensures businesses have access to best-in-class API services that drive growth and efficiency.
              </Typography>
              <Typography variant="body1" color="text.secondary" sx={{ mt: 2, lineHeight: 1.6 }}>
                We believe in <strong >collaboration</strong>, <strong >continuous learning</strong>, and <strong >customer success</strong>.
                Whether you need assistance with custom API development, integration, or optimization,
                our team is here to help at every step.
              </Typography>
            </Typography>
            <SecondaryButton text="Contact Us" to="/about" />
          </Box>
          <Box sx={{ flex: 1 }} className={slideRightClass}>
            <img
              src={teamWork}
              alt="About Us"
              title="Learn more about us"
              width={500}
              height={316}
              loading="lazy"
              style={{
                borderRadius: '24px',
                maxWidth: '100%',
              }}
            />
          </Box>
        </Box>
      </Container>
    </Box>
  );
}
